import { render, staticRenderFns } from "./TarjetaDeOperaciones.vue?vue&type=template&id=683b1069&scoped=true"
import script from "./TarjetaDeOperaciones.vue?vue&type=script&lang=js"
export * from "./TarjetaDeOperaciones.vue?vue&type=script&lang=js"
import style0 from "./TarjetaDeOperaciones.vue?vue&type=style&index=0&id=683b1069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b1069",
  null
  
)

export default component.exports